import React from "react";
import { DropdownSelector } from "./DropdownSelector";
import { useApplicationContext } from "../context/ApplicationContext";

/**
 * AccountSelector - Displays and allows switching between different OHID accounts
 *
 * Accounts are fetched during app initialization (see useAuthentication) and stored in
 * ApplicationContext. Selecting a different account opens the shared confirm modal;
 * switching accounts refreshes the platform list scoped to the newly selected account.
 */
export const AccountSelector: React.FC = () => {
  const { accounts, currentAccount, openSwitchModal } = useApplicationContext();

  // Nothing to select yet (still loading); avoid a blank trigger that opens an empty menu.
  if (accounts.length === 0) {
    return null;
  }

  return (
    <DropdownSelector
      ariaLabel="Open account menu"
      selectedValue={currentAccount}
      options={accounts.map(({ id, label }) => ({ value: id, label }))}
      onSelect={(account) => {
        if (account !== currentAccount) {
          openSwitchModal("account", account);
        }
      }}
      valueTestId="selected-account"
      variant="text"
      fallbackLabel=""
    />
  );
};
